// 商品クイックビューモーダル
class ProductQuickView {
  constructor() {
    this.modal = document.getElementById('productQuickViewModal');
    this.closeBtn = this.modal?.querySelector('.quick-view-close');
    this.addToCartBtn = this.modal?.querySelector('#quickViewAddToCart');
    this.quantityInput = this.modal?.querySelector('.quick-view-quantity-input');
    this.minusBtn = this.modal?.querySelector('.quick-view-quantity-minus');
    this.plusBtn = this.modal?.querySelector('.quick-view-quantity-plus');

    this.currentProduct = null;
    this.selectedVariant = null;

    this.init();
  }

  init() {
    if (!this.modal) {
      console.error('クイックビューモーダルが見つかりません');
      return;
    }

    // 閉じるボタン
    this.closeBtn?.addEventListener('click', () => this.close());

    // オーバーレイクリックで閉じる
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) {
        this.close();
      }
    });

    // 数量調整
    this.minusBtn?.addEventListener('click', () => this.changeQuantity(-1));
    this.plusBtn?.addEventListener('click', () => this.changeQuantity(1));

    // カートに追加
    this.addToCartBtn?.addEventListener('click', () => this.addToCart());

    // ESCキーで閉じる
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.style.display === 'flex') {
        this.close();
      }
    });

    console.log('ProductQuickView initialized');
  }

  async open(productHandle) {
    if (!productHandle) {
      console.error('商品ハンドルが指定されていません');
      alert('商品情報の取得に失敗しました。');
      return;
    }

    console.log('商品を開きます:', productHandle);

    try {
      // 商品データを取得
      const url = `/products/${productHandle}.js`;
      console.log('Fetching:', url);

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const text = await response.text();

      if (!text) {
        throw new Error('空のレスポンスが返されました');
      }

      this.currentProduct = JSON.parse(text);
      console.log('商品データ:', this.currentProduct);

      // モーダルに商品情報を表示
      this.renderProduct();

      // モーダルを表示
      this.modal.style.display = 'flex';
      setTimeout(() => this.modal.classList.add('active'), 10);
      document.body.style.overflow = 'hidden';

    } catch (error) {
      console.error('商品の読み込みに失敗しました:', error);
      alert(`商品の読み込みに失敗しました。\n商品ハンドル: ${productHandle}\nエラー: ${error.message}`);
    }
  }

  close() {
    this.modal.classList.remove('active');
    setTimeout(() => {
      this.modal.style.display = 'none';
      document.body.style.overflow = '';
    }, 300);
  }

  renderProduct() {
    const product = this.currentProduct;

    try {
      // 画像
      const image = this.modal.querySelector('#quickViewProductImage');
      if (image) {
        image.src = product.featured_image;
        image.alt = product.title;
      }

      // タイトル（オプション）
      const titleElement = this.modal.querySelector('#quickViewProductTitle');
      if (titleElement) {
        titleElement.textContent = product.title;
      }

      // 価格
      const priceElement = this.modal.querySelector('#quickViewProductPrice');
      if (priceElement) {
        const price = (product.price / 100).toLocaleString('ja-JP');
        const firstVariant = product.variants[0];

        let priceHTML = '';

        // 値引き前価格が存在する場合
        if (firstVariant && firstVariant.compare_at_price && firstVariant.compare_at_price > firstVariant.price) {
          const comparePrice = (firstVariant.compare_at_price / 100).toLocaleString('ja-JP');
          const discountRate = Math.round(((firstVariant.compare_at_price - firstVariant.price) / firstVariant.compare_at_price) * 100);

          priceHTML = `
            <div class="price-wrapper">
              <div class="price-current-wrapper">
                <span class="price-amount">¥${price}</span>
                <span class="price-tax">（税込）</span>
              </div>
              <div class="price-discount-info">
                <span class="price-discount-rate">${discountRate}% Off</span>
                <span class="price-divider">/</span>
                <span class="price-compare-label">定価：</span>
                <span class="price-compare">¥${comparePrice}</span>
              </div>
            </div>
          `;
        } else {
          // 通常価格のみ
          priceHTML = `
            <span class="price-amount">¥${price}</span>
            <span class="price-tax">（税込）</span>
          `;
        }

        priceElement.innerHTML = priceHTML;
      }

      // バリエーション
      this.renderVariants();

      // デフォルトのバリアントを選択
      this.selectedVariant = product.variants[0];


      console.log('商品情報のレンダリング完了');
    } catch (error) {
      console.error('商品情報の表示中にエラー:', error);
      throw error;
    }
  }

  renderVariants() {
    const variantsContainer = this.modal.querySelector('#quickViewVariants');
    const product = this.currentProduct;

    if (product.variants.length === 1 && product.variants[0].title === 'Default Title') {
      variantsContainer.style.display = 'none';
      return;
    }

    variantsContainer.innerHTML = '';
    variantsContainer.style.display = 'grid';

    product.variants.forEach((variant, index) => {
      const button = document.createElement('button');
      button.className = 'quick-view-variant-btn';
      button.textContent = variant.title;
      button.dataset.variantId = variant.id;

      if (!variant.available) {
        button.classList.add('disabled');
        button.disabled = true;
      }

      // 最初のバリアントを選択状態に
      if (index === 0 && variant.available) {
        button.classList.add('active');
        this.selectedVariant = variant;

        this.selectVariant(variant, button);
      }

      button.addEventListener('click', () => {
        if (variant.available) {
          this.selectVariant(variant, button);
        }
      });

      variantsContainer.appendChild(button);
    });
  }

  selectVariant(variant, button) {
    this.selectedVariant = variant;

    // すべてのボタンからactiveクラスを削除
    this.modal.querySelectorAll('.quick-view-variant-btn').forEach(btn => {
      btn.classList.remove('active');
    });

    // クリックされたボタンにactiveクラスを追加
    button.classList.add('active');

    // 価格を更新
    const price = (variant.price / 100).toLocaleString('ja-JP');
    const priceElement = this.modal.querySelector('#quickViewProductPrice');

    if (priceElement) {
      let priceHTML = '';

      // 値引き前価格が存在する場合
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const comparePrice = (variant.compare_at_price / 100).toLocaleString('ja-JP');
        const discountRate = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);

        priceHTML = `
          <div class="price-wrapper">
            <div class="price-current-wrapper">
              <span class="price-amount">¥${price}</span>
              <span class="price-tax">（税込）</span>
            </div>
            <div class="price-discount-info">
              <span class="price-discount-rate">${discountRate}% Off</span>
              <span class="price-divider">/</span>
              <span class="price-compare-label">定価：</span>
              <span class="price-compare">¥${comparePrice}</span>
            </div>
          </div>
        `;
      } else {
        // 通常価格のみ
        priceHTML = `
          <span class="price-amount">¥${price}</span>
          <span class="price-tax">（税込）</span>
        `;
      }

      priceElement.innerHTML = priceHTML;
    }

    // 画像を更新（バリアントに画像がある場合）
    if (variant.featured_image) {
      const imageElement = this.modal.querySelector('#quickViewProductImage');
      if (imageElement) {
        imageElement.src = variant.featured_image.src;
        imageElement.alt = variant.name || this.currentProduct.title;
        console.log('画像を更新:', variant.featured_image.src);
      }
    }

    // バッジを更新
    const badgeElement = this.modal.querySelector('.quick-view-badge');
    if (badgeElement) {
      badgeElement.textContent = variant.title;
      console.log('バッジを更新:', variant.title);
    }

    console.log('バリアント選択:', variant.title, '価格:', price);
  }

  changeQuantity(delta) {
    const currentValue = parseInt(this.quantityInput.value);
    const newValue = Math.max(1, Math.min(99, currentValue + delta));
    this.quantityInput.value = newValue;
  }

  async addToCart() {
    if (!this.selectedVariant) return;

    const quantity = parseInt(this.quantityInput.value);
    const button = this.addToCartBtn;
    const originalText = button.innerHTML;

    try {
      // ボタンをローディング状態に
      button.disabled = true;
      button.innerHTML = '追加中...';

      // カートに追加
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: this.selectedVariant.id,
          quantity: quantity
        })
      });

      if (response.ok) {
        // 成功
        button.innerHTML = '✓ 追加しました';

        // カートカウントを更新
        this.updateCartCount();

        // カート画面に遷移
        setTimeout(() => {
          window.location.href = '/cart';
        }, 500);
      } else {
        throw new Error('カートへの追加に失敗しました');
      }

    } catch (error) {
      console.error(error);
      button.innerHTML = 'エラーが発生しました';
      setTimeout(() => {
        button.innerHTML = originalText;
        button.disabled = false;
      }, 2000);
    }
  }

  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      const cartCountElements = document.querySelectorAll('.cart-count, #cart-icon-bubble');
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
        if (cart.item_count > 0) {
          element.style.display = 'block';
        }
      });
    } catch (error) {
      console.error('カート数の更新に失敗しました:', error);
    }
  }
}

// 初期化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQuickView);
} else {
  initQuickView();
}

function initQuickView() {
  window.productQuickView = new ProductQuickView();
  console.log('ProductQuickView ready');
}

// グローバル関数
window.openQuickView = function(productHandle) {
  console.log('openQuickView called with:', productHandle);
  if (window.productQuickView) {
    window.productQuickView.open(productHandle);
  } else {
    console.error('ProductQuickView not initialized');
  }
};

console.log('product-quick-view.js loaded');
